import ReactGA from 'react-ga'
import { store } from 'store/store'

export const Event = (id, nonInteraction=false, label="") => {
  let user = store.getState().userSession.tenantId;
  user = user ? user : "unk";
  let e = {category:user, action:id};
  if (nonInteraction) {
    e.nonInteraction = true;
  }
  if (label !== "") {
    e.label = label;
  }
  console.debug("GA Event: " + JSON.stringify(e));
  ReactGA.event(e);
};
